import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Carousel.scss';

function CarouselItem({ img, title, text, subtitle }) {
  return (
    <div className="audicarousel__item">
      <img className="audicarousel__img" alt="" src={img} />
      <div className="audicarousel__content">
        <h5 className="audicarousel__subtitle">{title}</h5>
        <p className="audicarousel__subtitle--small">{subtitle}</p>
        <p className="audicarousel__text">{text}</p>
      </div>
    </div>
  );
}

function StoryCarousel(props) {
  const assets = process.env.PUBLIC_URL + '/Assets/';
  const {
    content: { title, textBlocks, slides },
    deviceWidth,
    containerClass = ''
  } = props;

  return (
    <section className={`section section--carousel ${containerClass}`}>
      <div className="section__wrapper">
        {title && (
          <div className="section__head">
            <h3 className="section__title blue-underline">{title}</h3>
          </div>
        )}
        <div className="section__content audicarousel">
          {textBlocks && (
            <div className="audicarousel__introText">
              {textBlocks.map((el, i) => {
                return <p key={i}>{el.text}</p>;
              })}
            </div>
          )}
          {slides.length > 1 ? (
            <div className="audicarousel__slider">
              <Carousel
                autoPlay
                showThumbs={false}
                infiniteLoop={true}
                emulateTouch={true}
                interval={6000}
                transitionTime={600}
                showStatus={false}
                swipeScrollTolerance={1}
              >
                {slides.map((el, i) => {
                  return (
                    <CarouselItem
                      key={i}
                      img={assets + (deviceWidth >= 660 ? el.img.desktop : el.img.mobile)}
                      title={el.title ? el.title : ''}
                      text={el.text}
                      subtitle={el.subtitle ? el.subtitle : ''}
                    />
                  );
                })}
              </Carousel>
            </div>
          ) : (
            <CarouselItem
              img={assets + (deviceWidth >= 660 ? slides[0].img.desktop : slides[0].img.mobile)}
              title={slides[0].title ? slides[0].title : ''}
              text={slides[0].text}
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default StoryCarousel;
